<template>
	<v-container class="ma-0 pa-0 terms_container" fill-height>
		<v-row dense class="ma-0 pa-0">
			<v-col cols="12" align-self="start" align="center" class="ma-0 px-0 pt-10 pb-5 terms_selvy_title">
                <v-img
                    :src="require('@/assets/images/code-logo-w.png')"
                    alt="로고"
					width="100vmin"
                />
			</v-col>
			<v-col cols="12" align-self="start" align="center" class="ma-0 py-5 px-7 terms_selvy_title">
				<p style="color: white;">셀비체크업 건강 분석 서비스 이용을 위해 서비스 이용 약관에 동의해 주세요.</p>
			</v-col>
		</v-row>
		<v-row dense class="ma-0 pa-0 px-7">
			<v-col cols="12" align-self="center">
				<div class="terms_title">약관동의</div>
				<div class="terms_description">
					본 서비스는 1회성으로 고객님의 정보를 저장하지 않습니다.
				</div>
				<div class="ck_u_all" style="border-bottom:1px solid #b4bcca;">
					<input
						v-model="userInfo.isTermsAgreeAll"
						type="checkbox"
						id="termsAll"
						class="terms_check"
						@click.stop="termsAgreeAll"
					/>
					<label
						for="termsAll"
						tabindex="2"
						role="checkbox"
						@keydown.enter="userInfo.isTermsAgreeAll = !userInfo.isTermsAgreeAll"
					>
						전체 동의하기
					</label>
				</div>
				<div class="ck_u mt-5">
					<input
						v-model="userInfo.isTermsAgree1"
						type="checkbox"
						id="terms1"
						class="terms_check"
					/>
					<label
						for="terms1"
						tabindex="2"
						role="checkbox"
						@keydown.enter="userInfo.isTermsAgree1 = !userInfo.isTermsAgree1"
					>
						이용 약관 동의
					</label>
					<a
						href="javacript:;"
						class="privacy_link"
						role="link"
						tabindex="3"
						@click="showPopup(1)"
					>
						보기
					</a>
				</div>
				<div class="ck_u mt-5">
					<input
						v-model="userInfo.isTermsAgree2"
						type="checkbox"
						id="terms2"
						class="terms_check"
					/>
					<label
						for="terms2"
						tabindex="4"
						role="checkbox"
						@keydown.enter="userInfo.isTermsAgree2 = !userInfo.isTermsAgree2"
					>
						개인정보 수집 및 이용동의 (필수)
					</label>
					<a
						href="javacript:;"
						class="privacy_link"
						tabindex="5"
						role="link"
						@click="showPopup(2)"
					>
						보기
					</a>
				</div>
				<div class="ck_u mt-5">
					<input
						v-model="userInfo.isTermsAgree3"
						type="checkbox"
						id="terms3"
						class="terms_check"
					/>
					<label
						for="terms3"
						tabindex="6"
						role="checkbox"
						@keydown.enter="userInfo.isTermsAgree3 = !userInfo.isTermsAgree3"
					>
						민감정보 수집 및 이용동의 (필수)
					</label>
					<a
						href="javacript:;"
						class="privacy_link"
						tabindex="7"
						role="link"
						@click="showPopup(3)"
					>
						보기
					</a>
				</div>
				<div class="err_ly">
					<p
						v-if="errorBag.name"
						class="err_msg"
					>
						{{ errorBag.name[0] }}
					</p>
				</div>
			</v-col>
		</v-row>

		<v-col cols="12" align-self="end" class="ma-0 pa-0">
			<v-row class="ma-0 pa-0">
				<v-col cols="3" class="ma-0 pa-0">
					<v-btn
						elevation="0"
						class="tearms_cancel_btn"
						block
						tabindex="8"
						@click="cancle"
						tile
						v-ripple
					>
						취소
					</v-btn>
				</v-col>
				<v-col cols="9" class="ma-0 pa-0">
					<v-btn
						elevation="0"
						block
						:class="this.enableButton ? 'tearms_start_enable_btn' : 'tearms_start_disable_btn'"
						:disabled="!this.enableButton"
						tabindex="9"
						@click="goStart"
						tile
						v-ripple
					>
						시작하기
					</v-btn>
				</v-col>
			</v-row>
		</v-col>

		<!-- popup -->
		<VAccessPopup v-if="popupView1" @closePop="closePopup"></VAccessPopup>
		<VPersonalPopup v-if="popupView2" @closePop="closePopup"></VPersonalPopup>
		<VSensitivePopup v-if="popupView3" @closePop="closePopup"></VSensitivePopup>
        <VToast ref="toast"></VToast>
		<!-- // popup -->
	</v-container>
</template>

<script>
	import { mapActions } from 'vuex'
	import VAccessPopup from "@/components/popup/accessTermsPopup.vue"
	import VPersonalPopup from "@/components/popup/personalTermsPopup.vue"
    import VSensitivePopup from "@/components/popup/sensitiveTermsPopup.vue"
    import VToast from "@/components/popup/toast.vue"

	export default {
		components: {
			VAccessPopup,
			VPersonalPopup,
            VSensitivePopup,
            VToast
		},

		data: () => ({
			userInfo: {
				isTermsAgree1: false,
				isTermsAgree2: false,
				isTermsAgree3: false,
			},

			errorBag: {
				name: [],
			},

			customerCode: "",

			popupView1: false,
			popupView2: false,
			popupView3: false,

			enableButton: false,

			prevScrollY: 0,
			errorMsg: ''
		}),

		methods: {
			...mapActions('user', [
                'logout',
				'signupWithCode',
				'setAuthToken',
                'setManagerCode',
			]),
			...mapActions('survey', [
                'setStep',
                'clearCheckupTemp'
			]),

			// 공통 팝업 오픈
			showPopup(type) {
				this.prevScrollY = window.scrollY;
				window.scrollTo(0, 0);
				this[`popupView${type}`] = !this[`popupView${type}`];
			},
			// 공통 팝업 종료
			closePopup(type) {
				window.scrollTo(0, this.prevScrollY);
				this.prevScrollY = 0;
				this[`popupView${type}`] = !this[`popupView${type}`];
			},
			//취소
			cancle() {
				//this.$router.push("/");
				this.$router.go(-1);
			},
			//시작하기
			async goStart() {
				if (
                    !this.userInfo.isTermsAgree1 ||
                    !this.userInfo.isTermsAgree2 ||
                    !this.userInfo.isTermsAgree3
                ) {
                    return this.$refs.toast.open('약관을 동의해주세요.')
                }

				//const res = await this.signupWithCode(this.customerCode)
				const res = await this.signupWithCode('gnadmin')	// admin account for gangnam-gu
                const resultCode = Number(res.data.code)
				if(resultCode === 200) {
                    // 기존 정보 모두 삭제
                    this.logout()
                    this.clearCheckupTemp()

					this.setAuthToken(res.data.result.token)
					this.setManagerCode(this.customerCode)
					this.setStep(1)
					this.$router.push(`/checkup/step1`)
				}
				else if(resultCode === 400) {
                    this.$refs.toast.open(this.$t('error.signin.invalidCode'))
				}
                else if(resultCode === 500) {
                    this.$refs.toast.open(this.$t('error.common.internalServer'))
                }
                else
                {
                    console.log(res)
                    this.$refs.toast.open(this.$t('error.common.unkonwn', resultCode))
				}
			},
			//버튼활성화
			buttonChange() {
				if (this.userInfo.isTermsAgree1 && this.userInfo.isTermsAgree2 && this.userInfo.isTermsAgree3 ) {
					this.userInfo.isTermsAgreeAll = true
				} else if (!this.userInfo.isTermsAgree1 || !this.userInfo.isTermsAgree2 || !this.userInfo.isTermsAgree3) {
					this.userInfo.isTermsAgreeAll = false
				}
				this.enableButton =
					this.userInfo.isTermsAgree1 &&
					this.userInfo.isTermsAgree2 &&
					this.userInfo.isTermsAgree3
			},
			termsAgreeAll () {
				if( !this.userInfo.isTermsAgree1 || !this.userInfo.isTermsAgree2 || !this.userInfo.isTermsAgree3) {
					this.userInfo.isTermsAgree1 = true
					this.userInfo.isTermsAgree2 = true
					this.userInfo.isTermsAgree3 = true
				} 
				
				else if (this.userInfo.isTermsAgree1 && this.userInfo.isTermsAgree2 && this.userInfo.isTermsAgree3 ){
					this.userInfo.isTermsAgree1 = false
					this.userInfo.isTermsAgree2 = false
					this.userInfo.isTermsAgree3 = false
				} 
			}
		},
		watch: {
			customerCode: function() {
				this.errorMsg = ''
				this.buttonChange()
			},
			"userInfo.isTermsAgree1": function() {
				this.buttonChange()
			},
			"userInfo.isTermsAgree2": function() {
				this.buttonChange()
			},
			"userInfo.isTermsAgree3": function() {
				this.buttonChange()
			},
			"userInfo.isTermsAgreeAll": function() {
				this.buttonChange()
			}
        },
        mounted() {
            window.scrollTo(0, 0)
        }
	};
</script>

<style scoped lang="scss">
	.terms_check {
		display: none;
		position: absolute;
		z-index: -1;
	}

	.terms_check + label {
		background: url(~@/assets/images/renew/ico-check-off.svg) no-repeat;
		display: inline-block;
		padding: 0 0 0 30px;
        cursor: pointer;
        height: 24px;
	}

	.terms_check:checked + label {
		background: url(~@/assets/images/renew/ico-check-on.svg) no-repeat;
		display: inline-block;
		padding: 0 0 0 30px;
		cursor: pointer;
	}

	.ck_u {
        font-family: NanumSquare, sans-serif;
        font-size: 14px;
        color: #475b82;
        vertical-align: middle;
        line-height: 24px;
        position: relative;
	}

	.ck_u_all {
		font-family: NanumSquare, sans-serif;
        font-size: 16px;
		font-weight: 700;
        color: #475b82;
        height: 48px;
        vertical-align: middle;
        line-height: 24px;
        position: relative;
	}

	.terms {
		padding: 4vh 6vw 0px 6vw;
        max-width: 500px;
        margin: auto;
	}

	.terms_title {
        font-family: NanumSquare, sans-serif;
        font-weight: 700;
		font-size: 18px;
        color: #202020;
        font-weight: bold;
	}

	.terms_description {
        font-family: NanumSquare, sans-serif;
		font-size: 14px;
		color: #767676;
        margin-top: 5px;
        margin-bottom: 3vh;
	}

	.ck_u {
        font-family: NanumSquare, sans-serif;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.87);
        height: 48px;
        vertical-align: middle;
        line-height: 24px;
        position: relative;
	}

	.privacy_link {
        font-family: NanumSquare, sans-serif;
        font-size: 14px;
        position: absolute;
		right: 0vw;
		color: #767676;
	}

	.err_ly {
		margin-top: 2vh;
	}

	.err_msg {
        font-family: NanumSquare, sans-serif;
		font-size: 2vh;
		color: #ea5858;
		text-align: center;
	}

	.footer_btn_group {
		align-self: flex-end;
        position: relative;
    }

	.tearms_cancel_btn {
		height: 60px !important;
		background-color: #dcdfe6 !important;
		color: #193263;
		font-weight: 700;
        font-family: NanumSquare, sans-serif !important;
	}

	.tearms_start_enable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif;
        color: white !important;
		border: 0;
		outline: none;
	}

	.tearms_start_disable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif !important;
        color: white !important;
		border: 0;
		outline: none;
    }

	::v-deep .tearms_start_disable_btn .v-btn__content {
		color: white !important;
	}

	::v-deep .tearms_start_enable_btn .v-btn__content {
		color: white !important;
	}

	.terms_container {
		word-break: keep-all;
        align-items: baseline !important;
    }

	.user_terms_title_descript {
		font-size: 18px;
		color: #193263;
		line-height:26px;
		letter-spacing: -0.6px;
	}

	.terms_selvy_title {
		background-color: #193263;
	}

	button:disabled,
	button[disabled] {
		color: #ffffff !important;
		// background-color: #a7bdff !important;
		border: solid 0 #a7bdff !important;
	}

</style>
